/**
 * Contains types of pages
 */
export enum PageType {
  /**
   * Contact Page
   */
  Contact = 0
}
